/**
 *  CompetitorsWidget script file
**/

import layerids from '@/api/layerids'
import layerService, { tooltipStyle } from '@/api/layerService'
import queries from '@/api/queries'
import apiService from '@/api/apiService'
import hex2rgb from '@/utils/hex2rgb'

const allCategories = () => ({ id: 'all', name: 'Todas las categorías' })
const allBrands = () => ({ id: 'all', name: 'Todas las marcas' })

// const NULL_COLOR = [0, 0, 0, 0]
// const CATEGORY_COLOR = [255, 205, 3, 255]
const CATEGORY_LINE_COLOR = [255, 255, 255]

/* eslint-disable */
const CATEGORY_COLORS = {
  "CONSOLAS Y VIDEOJUEGOS": hex2rgb('#47EE90'),
  "PERFUMERIA Y MAQUILLAJE": hex2rgb('#D0F8DA'),
  "HOGAR": hex2rgb('#3969AC'),
  "JUGUETES": hex2rgb('#34D7E6'),
  "GRAN CONSUMO": hex2rgb('#FBD103'),
  "OCIO Y CULTURA": hex2rgb('#FCEB93'),
  "TECNOLOGIA": hex2rgb('#FE5821'),
  "MODA": hex2rgb('#F7CAB4'),
  "DEPORTES": hex2rgb('#6A0867'),
  "MASCOTAS": hex2rgb('#CEB2D4'),
  null: hex2rgb('#222')
}
/* eslint-enable */

export default {
  name: 'CompetitorsWidget',
  mixins: [],
  components: {
    CollapsiblePercentBars: () => import(/* webpackChunkName: "CollapsiblePercentBars" */'@/components/collapsible-percent-bars/CollapsiblePercentBars.vue'),
    TagListSelector: () => import(/* webpackChunkName: "TagListSelector" */'@/components/tag-list-selector/TagListSelector.vue')
  },
  props: {
    areas: {
      type: Array,
      required: true
    },
    areatype: {
      type: String,
      required: true
    },
    widget: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      ...layerids,
      loading: true,
      selectedCategories: [allCategories()],
      categoryOptions: [],
      selectedBrands: [allBrands()],
      brandOptions: []
    }
  },
  computed: {
    centerid () {
      return this.$route.params.id
    }
  },
  watch: {
    async selectedCategories () {
      await this.fetchBrandOptions()
      this.updateCompetitorsLayer()
    },
    selectedBrands () {
      this.updateCompetitorsLayer()
    }
  },
  mounted () {
    this.createCompetitorsLayer()
    this.fetchCategoryOptions()
    this.fetchBrandOptions()
  },
  beforeDestroy () {
    layerService.removeLayer(this.competitorsLayerId)
  },
  methods: {
    async fetchCategoryOptions () {
      this.loading = true
      try {
        const data = await apiService.getCategoryOptions()
        this.categoryOptions = [allCategories()]
          .concat(data.map(d => ({ id: d, name: d, color: `rgb(${CATEGORY_COLORS[d]})` })))
      } catch (err) {
        // eslint-disable-next-line
        console.error('[competitors-widget.js] Error fetching category options', err)
      }
      this.loading = false
    },
    categoryIsSelected (category) {
      const allSelected = this.selectedCategories.length === 1 && this.selectedCategories[0].id === 'all'
      return allSelected || this.selectedCategories.some(c => c.id === category)
    },
    async fetchBrandOptions () {
      this.loading = true
      this.loading = false
      try {
        const data = await apiService.getBrandOptions({
          categories: this.selectedCategories.map(c => c.id).filter(id => id !== 'all')
        })
        this.brandOptions = [allBrands()]
          .concat(data.map(d => ({ id: d, name: d })))
        this.selectedBrands = [allBrands()]
      } catch (err) {
        // eslint-disable-next-line
        console.error('[competitors-widget.js] Error fetching brand options', err)
      }
    },
    brandIsSelected (brand) {
      const allSelected = this.selectedBrands.length === 1 && this.selectedBrands[0].id === 'all'
      return allSelected || this.selectedBrands.some(b => b.id === brand)
    },
    createCompetitorsLayer () {
      if (this.areas.length === 0) {
        return
      }
      const query = queries.competitors({
        centerid: this.centerid,
        areatype: this.areatype,
        areas: this.areas.filter(a => a !== 'all')
      })
      layerService.addSQLLayer({
        id: this.competitorsLayerId,
        sql: query,
        stroked: true,
        filled: true,
        pickable: true,
        zIndex: 3,
        getFillColor: object => {
          const category = object.properties.category
          return CATEGORY_COLORS[category]
        },
        getLineColor: CATEGORY_LINE_COLOR,
        lineWidthMinPixels: 2,
        pointRadiusMinPixels: 6,
        getTooltip: ({ object }) => {
          const { category, brandname } = object.properties
          const text = `${brandname} (${category})`
          return { text, style: tooltipStyle }
        }
      })
    },
    updateCompetitorsLayer () {
      if (this.areas.length === 0) {
        return
      }
      const query = queries.competitors({
        centerid: this.centerid,
        areatype: this.areatype,
        areas: this.areas.filter(a => a !== 'all'),
        categories: this.selectedCategories
          .filter(c => c.id !== 'all')
          .map(c => `$$${c.id}$$`),
        brands: this.selectedBrands
          .filter(b => b.id !== 'all')
          .map(b => `$$${b.id}$$`)
      })
      layerService.updateSQLLayer({ id: this.competitorsLayerId, sql: query })
    }
  }
}
